<template>
  <div class="customerPage">
    <headerNotice routerName="等级列表"></headerNotice>

    <div class="searchBox">
      <el-row :gutter="24">
        <el-col :span="2" :offset="2">
          <el-button type="primary" @click="addDistributionLevelConfig">
            <i class="el-icon-plus"></i> 新增
          </el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 搜索结果列表 -->
    <div class="searchList" v-loading="loading">
      <div class="searchListHead">
        <h2 class="searchListTitle">
          <i></i>
          <span>数据列表</span>
        </h2>
      </div>
      <div class="searchListContent">
        <el-table
          ref="searchListTable"
          :data="searchListTableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="customerSlelectionChange"
          border
        >
          <el-table-column align="center" type="selection" prop="distributionLevelID" width="55"></el-table-column>
          <el-table-column align="center" prop="levelName" label="等级名称"></el-table-column>

          <el-table-column align="center" prop="distributionNumber" label="分销人数"></el-table-column>
          <el-table-column align="center" prop="minSatisfactionPoint" label="佣金满足点"></el-table-column>
          <el-table-column align="center" prop="downCount" label="满足下线人数"></el-table-column>
          <el-table-column
            align="center"
            prop="oneCommission"
            label="上一级佣金奖励"
            :formatter="percentageformatter"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="twoCommission"
            label="上二级佣金奖励"
            :formatter="percentageformatter"
          ></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="240">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onEditDistribution(scope.row)">编辑</el-button>
              <!-- 上级要求暂时隐藏删除功能 -->
              <el-button type="text" size="small" @click="deleteDistribution(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--搜索列表分页-->
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      totalCount: 0, //总数据条数
      couponTotalCount: 0,
      customerSalesmanTotalCount: 0,
      maxResultCount: 10, //默认一页显示的个数,
      currentPage: 1,
      currentPage_salesman: 1,
      currentPage_coupon: 1,
      userId: "",
      searchForm: {
        //搜索表单
      },
      searchListTableData: [] //搜索列表数据
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      GetDistributionLevel: this.maxResultCount
    });
  },
  methods: {
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/DistributionLevelConfig/GetDistributionLevelList",
        params: params,
        success(res) {
          self.searchListTableData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },

    percentageformatter(row, column, value) {
      return value + "%";
    },
    //搜索
    onSearch(params) {
      let self = this;
      let form = this.searchForm;
      //关闭弹窗
      // this.dialogSearchForm2Visible = false;
      form.SkipCount = 0;
      this.getDatas(form);
      this.currentPage = 1;
    },

    //客户列表选中
    customerSlelectionChange(val) {
      this.customerSlelection = val;
      console.log(this.customerSlelection);
    },

    //编辑等级
    onEditDistribution(row) {
      this.$router.push({
        path: "/editdistributionLevelConfig",
        query: {
          distributionLevelID: row.distributionLevelID
        }
      });
    },

    //删除等级
    deleteDistribution(row) {
      this.$confirm("此操作将永久删除该等级, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let self = this;
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/DistributionLevelConfig/DeleteDistributionLevel",
            params: { Id: row.distributionLevelID },
            success(res) {
              console.log(res);
              self.$message({
                type: "success",
                message: res.data
              });
              self.getDatas({
                MaxResultCount: self.maxResultCount
              });
              self.currentPage = 1;
            },
            fail(res) {
              console.log(res);
              self.$message({
                type: "error",
                message: res.message
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //新增界面
    addDistributionLevelConfig() {
      this.$router.push({
        path: "/adddistributionLevelConfig"
      });
    },

    //搜索列表一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      this.getDatas(params);
    },
    //搜索列表跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.searchForm;
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getDatas(params);
    }
  }
};
</script>

<style lang='scss' scoped>
.customerPage {
  //搜索框
  .searchBox {
    margin: 20px 0px;
    //border: 1px solid #c5c5c5;
    .searchTitle {
      display: flex;
      align-items: center;
      height: 40px;
      margin-bottom: 10px;
      padding-left: 20px;
      background: #efefef;
      border-bottom: 1px solid #c5c5c5;
      i {
        width: 24px;
        height: 24px;
        background: url("../../assets/imgs/search01.png");
      }
    }
    .searchForm {
      display: flex;
      align-items: center;
      height: 60px;
      padding-left: 20px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
  //搜索列表
  .searchList {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchListHead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding-left: 20px;
      background: #efefef;
      border-bottom: 1px solid #c5c5c5;
      .searchTitle {
        i {
          width: 24px;
          height: 24px;
          background: url("../../assets/imgs/search02.png");
        }
      }
      .searchListCtl {
        button,
        .el-select {
          width: 130px;
          margin-left: 10px;
        }
      }
    }
    .searchListContent {
      .detialSpan {
        color: #ff9400;
        cursor: pointer;
      }
    }
  }
  //查看详情
  .editCustomer {
    .content {
      margin: 20px 50px;
      border: 1px solid #c5c5c5;
      .editTitle {
        display: flex;
        width: 100%;
        height: 40px;
        margin-bottom: 10px;
        align-items: center;
        border-bottom: 1px solid #c5c5c5;
        h2 {
          padding-left: 20px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.customerPage {
  .el-dialog__header {
    background: #efefef;
    border-bottom: 1px solid #c5c5c5;
  }
  .advancedSearch {
    .el-input {
      width: 81%;
    }
    .el-select > .el-input {
      width: 101.5%;
    }
  }
}
.changeBalanceIntegralForm {
  .el-input-group {
    width: 80%;
  }
  .el-radio {
    margin-right: 20px;
  }
  .el-textarea {
    width: 96.5%;
  }
}
</style>